import { defineMessages } from "react-intl";

export const FormErrorMessageText = defineMessages({
  imgAlt: {
    defaultMessage: "Form is unavailable",
    id: "wrKyH3",
  },
  paymentRequiredHeader: {
    defaultMessage: "This Form Is Unavailable",
    id: "GHYtHn",
  },
  paymentRequiredDescription: {
    defaultMessage:
      "The SmartSuite plan for this workspace is no longer active, so the form can't accept responses.",
    id: "vczW5O",
  },
  genericHeader: {
    defaultMessage: "Something Went Wrong",
    id: "7CTOHN",
  },
  genericDescription: {
    defaultMessage:
      "We couldn't load this form. Please check your connection and refresh the page.",
    id: "9/u/k1",
  },
  errorCode: {
    defaultMessage: "Error code: {statusCode}",
    id: "V7STQQ",
  },
});
